import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OrderSuccess() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) {
      fetchOrder();
    }
  }, [orderId]);

  const fetchOrder = async () => {
    try {
      const response = await axios.get(`${API}/orders/${orderId}`);
      setOrder(response.data);
    } catch (error) {
      console.error('Failed to fetch order:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-24 flex items-center justify-center">
      <div className="max-w-2xl w-full mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center" data-testid="order-success">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          
          <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Спасибо за заказ!
          </h1>
          
          <p className="text-xl text-gray-600 mb-8">
            Ваш заказ №{orderId?.slice(0, 8)} успешно оформлен
          </p>

          {order && (
            <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left">
              <h3 className="font-semibold text-lg mb-4">Детали заказа:</h3>
              <div className="space-y-2 text-gray-600">
                <p><span className="font-medium">Имя:</span> {order.customer_name}</p>
                <p><span className="font-medium">Email:</span> {order.customer_email}</p>
                <p><span className="font-medium">Телефон:</span> {order.customer_phone}</p>
                <p><span className="font-medium">Сумма:</span> {order.final_total.toLocaleString('ru-RU')} ₽</p>
              </div>
            </div>
          )}

          <p className="text-gray-600 mb-8">
            Мы отправили подтверждение на вашу электронную почту.
            <br />Наш менеджер свяжется с вами в ближайшее время.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/catalog" data-testid="continue-shopping">
              <Button className="bg-sky-600 hover:bg-sky-700 text-white">
                Продолжить покупки
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}